
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/unterkuenfte",
      function () {
        return require("private-next-pages/[region]/[resort]/unterkuenfte.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/unterkuenfte"])
      });
    }
  